// extracted by mini-css-extract-plugin
export var arrowIcon = "styles-module--arrowIcon--3pypP";
export var author = "styles-module--author--vJHJq";
export var cite = "styles-module--cite--3JztP";
export var cta = "styles-module--cta--1Kuen";
export var designation = "styles-module--designation--3jUDn";
export var image = "styles-module--image--2IWky";
export var quote = "styles-module--quote--3yZtV";
export var quoteContainer = "styles-module--quoteContainer--vlNpl";
export var quoteWrap = "styles-module--quoteWrap--3YbkB";